export const ARROW_PATH =
    'M20,0,16.364,3.636,30.13,17.4H0V22.6H30.13L16.364,36.364,20,40,40,20Z'
export const CLASSES = {
    arrow: 'splide__arrow w-4 h-4 md:w-5 md:h-5 [&:is([disabled])]:opacity-60',
    prev: 'splide__arrow--prev transform -scale-x-100',
    pagination: 'splide__pagination',
    page: 'splide__pagination__page h-4 md:h-5 w-1 bg-black p-0 opacity-60 [&:is(.is-active)]:opacity-100 block',
}
